import { GENERIC_ANALYTICS_EVENTS } from 'Utilities/analytics/analyticsGenericEvents';

const HIGH_DEMAND_VEHICLE_CATEGORY = 'high_demand_vehicle';

const HIGH_DEMAND_VEHICLE_EVENT_NAME = {
  TOOLTIP_APPEARED: 'high_demand_tooltip_popup_appear',
} as const;

export const HIGH_DEMAND_VEHICLE_EVENTS = Object.freeze({
  TOOLTIP_APPEARED: (label?: string) => GENERIC_ANALYTICS_EVENTS.POPUP_LOAD_EVENT({
    category: HIGH_DEMAND_VEHICLE_CATEGORY,
    label,
    name: HIGH_DEMAND_VEHICLE_EVENT_NAME.TOOLTIP_APPEARED,
  }),
});
